export default __webpack_public_path__ + "static/icon-group-a6187531b2df022f2dbf8f12704a8116.svg";